import { PageOwnerType } from "../../enums/PageOwnerType";
import { Company } from "../../enums/Company";

export class ImportPageRequest {
    public PageID: string = ``;
    public OwnerType: PageOwnerType = PageOwnerType.Witco;
    public Company: Company = Company.CINC;
}
